import { forwardRef, useImperativeHandle } from 'react';
import { BadIcon, CorrectIcon } from './Icons';
import { motion, useAnimate } from 'framer-motion';
import classes from './Correction.module.scss';
import clsx from 'clsx';
import { NAME_SOUND_FAILURE, useGameSounds } from '@educaplay/core';
import { DICTADO_SOUNDS } from '../../utils/constants';

const Correction = forwardRef(function Correction(props, ref) {
    const { userAnswer, expected, animated } = props;
    const [pillRef, animatePill] = useAnimate();
    const [expectedRef, animateExpected] = useAnimate();
    const gameSounds = useGameSounds();

    useImperativeHandle(ref, () => ({
        getOffsetTop: () => pillRef.current.offsetTop,
        show: async () => {
            gameSounds.play(NAME_SOUND_FAILURE);
            await Promise.all([
                animatePill(pillRef.current, {
                    padding: '0 5px',
                    backgroundColor: 'var(--game-error-color)',
                    color: 'var(--error-text-color)',
                    textDecoration: 'line-through'
                }, { duration: 0.1 }),
                animatePill("[data-animate='icon']", {
                    opacity: 1,
                    display: "inline"
                }, { delay: 0.1, duration: 0.5 })
            ]);
            setTimeout(() => { gameSounds.play(DICTADO_SOUNDS.PLACE) }, 300);
            await animateExpected(expectedRef.current, {
                display: 'inline',
                opacity: 1
            }, { delay: .3, duration: 1 });
        }
    }));

    return (
        <>
            <motion.span
                initial={animated ? {
                    padding: '5px',
                    color: 'var(--element-text-color)',
                    backgroundColor: 'rgba(255, 160, 160, 0)',
                    textDecoration: 'none'
                } : null}
                className={clsx(classes.pill, classes.removed)}
                data-type="removed"
                ref={pillRef}
            >
                <motion.span
                    initial={animated ? { opacity: 0, display: "none" } : null}
                    data-animate="icon"
                    className={classes.removedicon}
                >
                    <BadIcon />
                </motion.span>
                <span>{userAnswer}</span>
            </motion.span>

            <motion.span
                initial={animated ? { display: 'none', opacity: 0 } : null}
                className={clsx(classes.pill, classes.added)}
                ref={expectedRef}
            >
                <span>{expected}</span>
                <span className={classes.addedicon}><CorrectIcon /></span>
            </motion.span>
        </>
    )
});

export default Correction;